<template>
  <div class="big5-input">
    <label>Big5 專用輸入框：</label>
    <input 
      type="text" 
      v-model="inputText" 
      @input="validateBig5"
      placeholder="請輸入中文..."
    />
    getBig5Length:{{ getBig5Length(inputText) }}
    <p v-if="errorMsg" style="color: red;">{{ errorMsg }}</p>
  </div>
</template>
<script>
 import iconv from 'iconv-lite';
export default {
  data() {
    return {
      inputText: '',
      errorMsg: '',
      // 預先建立編碼器，避免在 methods 裡重複建立影響效能
      encoder: new TextEncoder('big5', { NONSTANDARD_allowLegacyEncoding: true })
    };
  },
  methods: {
    getBig5Length(str) {
            // 將字串轉為 Big5 Buffer，無法編碼的字會變成 ?
            const buffer = iconv.encode(str, 'big5');
            return buffer.length;
    },
      isBig5(str) {
        // 嘗試將字串轉為 Big5 Buffer
        const buf = iconv.encode(str, 'big5');
        // 再從 Buffer 解碼為字串，如果編碼不相容，就會變形
        const decoded = iconv.decode(buf, 'big5');
    
    return str === decoded;
    },

   
    validateBig5(event) {
      
      const originalValue = event.target.value;
      //let filteredValue = '';
      let hasInvalid = false;
    hasInvalid = !this.isBig5(originalValue);
 
      // 逐字檢查
     
      // 如果發現非法字元，更新 model 並提示
    if(hasInvalid) {
        this.errorMsg = '偵測到非 Big5 字元，。';
       // this.inputText = filteredValue;
      } else {
        this.errorMsg = '';
      }
    }
  }
};
</script>